// A client secret is shown once: when an application is created and when it is
// rotated (#147). The server keeps only a hash, so the page that receives the
// secret is the only place it will ever exist. These decisions are kept pure so
// they can be tested without a browser.

// The application types that authenticate with a client secret. Public clients
// (spa, native) use PKCE instead and have none to show or rotate.
const CONFIDENTIAL_APP_TYPES = ['regular_web', 'machine_to_machine'];

/**
 * Whether applications of this type have a client secret.
 * @param {string} appType the application's saved type
 * @returns {boolean}
 */
export function isConfidentialAppType(appType) {
    return CONFIDENTIAL_APP_TYPES.includes(appType);
}

/**
 * The secret to reveal from a create or rotate response, or null when the
 * response carries none (a public client has no secret).
 * @param {{client_secret?: string}|null|undefined} response the API response
 * @param {{id: string, name: string}} app the application it belongs to
 * @returns {{appId: string, name: string, secret: string}|null}
 */
export function revealFromResponse(response, app) {
    const secret = response?.client_secret;
    if (typeof secret !== 'string' || secret === '') return null;
    return { appId: app.id, name: app.name, secret };
}

/**
 * The revealed secret, only while its own application is the one on screen, so
 * opening a different application never shows another one's secret.
 * @param {{appId: string}|null} revealed the held secret, if any
 * @param {string} appId the application being shown
 * @returns {{appId: string, name: string, secret: string}|null}
 */
export function revealedSecretFor(revealed, appId) {
    return revealed && revealed.appId === appId ? revealed : null;
}
